var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-list"},_vm._l((4),function(j){return _c('div',{key:j},_vm._l((5),function(i){return _c('img',{key:j*5+i,staticClass:"logo-tag",attrs:{"src":_vm.list[(j-1)*5+i-1],"width":"224px","height":"88px"}})}),0)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }